import { render } from "./IssuedPrescriptionsTab.vue?vue&type=template&id=a585059a"
import script from "./IssuedPrescriptionsTab.vue?vue&type=script&lang=js"
export * from "./IssuedPrescriptionsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__